import api from "./Api";

export const getUserById = (userId) => api.get(`Service/getUserById/${userId}`);

const buildUserUpdateFormData = (data) => {
  const formData = new FormData();

  formData.append("UserName", data.userName);
  formData.append("Email", data.email);
  formData.append("PhoneNumber", data.phoneNumber);
  formData.append("Address", data.address);
  formData.append("AlternativePhoneNumber", data.alternativePhoneNumber ?? "");
  formData.append("AlternativeEmail", data.alternativeEmail ?? "");
  formData.append("DateOfBirth", data.dateOfBirth ?? "");
  formData.append("Gender", data.gender ?? "");
  formData.append("Occupation", data.occupation ?? "");
  formData.append("Nationality", data.nationality ?? "");
  formData.append("ProfileImageUrl", data.profileImageUrl ?? "");
  formData.append("RemoveProfileImage", String(Boolean(data.removeProfileImage)));

  if (data.profileImage) {
    formData.append("ProfileImage", data.profileImage);
  }

  return formData;
};

export const updateUserById = (userId, data) =>
  api.put(`Service/updateUserById/${userId}`, buildUserUpdateFormData(data));
